import { DateTime } from 'luxon';
import { ZONE } from '@web/common';
import type { ParticipantNachversandResDto } from '@web/common';

export const NACHVERSAND_GREEN = '#3D7F53';

export const bodyTextProps = { size: '16px', c: '#202020', lh: '1.6' } as const;

export type Part2Appointment = NonNullable<
  ParticipantNachversandResDto['current']
>['appointment'];

export const formatPart2Date = (date: Date) =>
  DateTime.fromJSDate(date, { zone: ZONE }).toFormat('dd.MM.yyyy');
